import React, { Fragment } from 'react'
import {
  variables,
  Copy,
  NavItem,
  Hero,
  SectionFull,
  NavbarSub
} from '@website2018/da-dobsonville'
import Sticky from 'react-stickynode'
import { Link } from 'react-router-dom'
import { Helmet } from "react-helmet-async";
import { decode } from 'he';
import { getTaxLink, noComma, sanitarize } from '../../common/utils'

import qs from 'qs'
import * as R from 'ramda'
import SearchContainer from '../../containers/Data/SearchContainer'
import Asides from '../Asides/Asides'

class NewsroomTemplate extends React.Component {
  render() {
    const {
      page: p,
      site: { taxonomy, province }
    } = this.props
    const { fontWeight, colors } = variables

    const getTaxonomy = R.path(['refinementList', 'taxonomies', 'category', 0])
    const taxonomyHeadline = getTaxonomy(qs.parse(this.props.location.search))

    const refinements = [{
      title: 'Category',
      attribute: 'taxonomies.category'
    }]
    if (province.slug === 'gauteng') {
      refinements.push({
        title: 'Municipality',
        attribute: 'taxonomies.municipality'
      })
    }

    return [
      <Helmet
        defaultTitle={decode(p.seo.title !== '' ? p.seo.title : p.title.rendered)}
        meta={[
          {
            name: 'description',
            content: p.seo.metadesc !== '' ? p.seo.metadesc : p.excerpt.rendered
          },
          {
            name: 'og:title',
            content: p.seo['opengraph-title'] !== '' ? p.seo['opengraph-title'] : p.title.rendered
          },
          {
            name: 'og:description',
            content:
              p.seo['opengraph-description'] !== ''
                ? p.seo['opengraph-description']
                : p.excerpt.rendered
          },
          { name: 'og:url', content: `` },
          { name: 'og:site_name', content: `Democratic Alliance` },
          { name: 'og:type', content: `business` },
          { name: 'og:image', content: p.seo['opengraph-image'] || null },
          { name: 'fb:app_id', content: '1262049647255981' },
          { name: 'twitter:card', content: '”summary_large_image”' },
          { name: 'twitter:site', content: '@our_da' },
          {
            name: 'twitter:title',
            content: p.seo['twitter-title'] !== '' ? p.seo['twitter-title'] : p.title.rendered
          },
          {
            name: 'twitter:description',
            content:
              p.seo['twitter-description'] !== ''
                ? p.seo['twitter-description”']
                : p.excerpt.rendered
          },
          {
            name: 'twitter:image',
            content: p.seo['twitter-image'] !== '' ? p.seo['twitter-image'] : null
          }
        ]}
        htmlAttributes={{ lang: 'en' }}
      />,
      <Sticky enabled={true} top={'#mainNav'} innerZ="9998">
        <NavbarSub>
          <NavItem fontWeight={fontWeight.medium} color={colors.textBase} fs={'13px'} lh={'16px'}>
            <Link to={`/newsroom`}>Newsroom</Link>
          </NavItem>
          {taxonomy
            .filter(c => c.name !== 'News')
            .map(c => (
              <NavItem
                fontWeight={fontWeight.medium}
                color={colors.linkBlue}
                fs={'13px'}
                lh={'16px'}
              >
                <Link to={getTaxLink(c.taxonomy, c.name, 'newsroom')}>{c.name}</Link>
              </NavItem>
            ))}
        </NavbarSub>
        {province.slug === 'gauteng' && (
          <NavbarSub>
            <NavItem fontWeight={fontWeight.medium} color={colors.linkBlue} fs={'13px'} lh={'16px'}>
              <Link to="/newsroom/muni/Johannesburg">Johannesburg</Link>
            </NavItem>
            <NavItem fontWeight={fontWeight.medium} color={colors.linkBlue} fs={'13px'} lh={'16px'}>
              <Link to="/newsroom/muni/Tshwane">Tshwane</Link>
            </NavItem>
            <NavItem fontWeight={fontWeight.medium} color={colors.linkBlue} fs={'13px'} lh={'16px'}>
              <Link to="/newsroom/muni/Ekurhuleni">Ekurhuleni</Link>
            </NavItem>
          </NavbarSub>
        )}
      </Sticky>,
      <Hero
        imageUrl={p.hero && p.hero.background_image ? p.hero.background_image.url : null}
        title={
          taxonomyHeadline
            ? sanitarize(taxonomyHeadline)
            : p.hero && p.hero.headline
            ? sanitarize(p.hero.headline)
            : p.title.rendered
        }
        bgPosition={p.hero && p.hero.focus_point && noComma(p.hero.focus_point)}
      />,
      <Fragment>
        {p.content.rendered && (
          <SectionFull>
            <div className={'col-lg-7'}>
              <Copy intro html={p.content.rendered} />
            </div>
          </SectionFull>
        )}
      </Fragment>,
      <SearchContainer
        showTitle={false}
        type="posts"
        refinements={refinements}
        defaultRefinement={{
          attribute: 'post_type_label',
          value: 'Posts'
        }}
        renderWidgets={() => <Fragment>{p.asides && <Asides asides={p.asides} />}</Fragment>}
        {...this.props}
      />
    ]
  }
}

export default NewsroomTemplate
